export default __webpack_public_path__ + "static/media/booksfiction.22e3fcbd.png";